import { Style } from '../..';

const EditMetadataRowStyles: Style = {
    updateButton: {
        width: '60px',
        height: '40px',
    },
    addMetadataTextfield: {
        width: '100%',
        height: '40px',
    },
};

export default EditMetadataRowStyles;
